<template>
  <div id="modalRenameCollection" class="modal">
    <div class="modal-content">
      <h4>{{ collection.name }} - zmiana nazwy</h4>
      <code>id: {{ collection?.id }}</code>
      <input v-model="localCollection.name" />
    </div>
    <div class="modal-footer">
      <a class="btn-flat text-white" @click="onRenameConfirmed()">Zapisz</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import admin from "@/admin";

export default {
  props: { collection: Object },

  data() {
    return {
      modal: null,
      localCollection: null,
    };
  },

  computed: {},

  watch: {},

  methods: {
    async onRenameConfirmed() {
      console.log("onRenameConfirmed", this.localCollection);

      await axios.patch(
        process.env.VUE_APP_API + "/api/apiCollections/" + this.collection.id,
        { itemIds: this.collection.itemIds, name: this.localCollection.name },
        {
          headers: {
            Authorization: "Bearer " + this.$store.getters.authToken,
          },
          params: {
            ref: "admin:collections:rename",
          },
        },
      );

      this.$emit("saved");
      this.modal.close();
    },
  },

  created() {
    console.debug("modalRenameCollection created");
    this.localCollection = JSON.parse(JSON.stringify(this.collection));
  },

  mounted() {
    console.debug("modalRenameCollection mounted");
    M.Modal.init(document.querySelectorAll("#modalRenameCollection"), {
      onCloseEnd: () => {
        console.log("modal on close end");
        this.$emit("modalClosed");
      },
    });

    this.modal = M.Modal.getInstance(
      document.querySelector("#modalRenameCollection"),
    );
    this.modal.open();
  },

  beforeDestroy() {
    console.log("modalRenameCollection beforeDestroy");
    this.modal.destroy();
  },
};
</script>

<style scoped></style>
